import React from "react";
import { Outlet, Path, generatePath, useResolvedPath } from "react-router-dom";
import DeviceGroupStore from "../store/device-group/DeviceGroupStore";
import LeftMenu from "./left-menu/LeftMenu";

interface PageLayoutOutletContext {
  baseUrl: Path;
  generatePath<Path extends string>(
    ...args: Parameters<typeof generatePath<Path>>
  ): string;
}

function PageLayout() {
  const baseUrl = useResolvedPath("");

  const context: PageLayoutOutletContext = React.useMemo(
    () => ({
      baseUrl,
      generatePath<Path extends string>(
        ...args: Parameters<typeof generatePath<Path>>
      ) {
        const pathname = baseUrl.pathname + generatePath(...args)
        // remove duplicated and ending "/"
        return "/" + pathname.split("/").filter(v => v).join("/");
      },
    }),
    [baseUrl]
  );

  return (
    <main>
      <DeviceGroupStore>
        <LeftMenu />
        <Outlet context={context} />
      </DeviceGroupStore>
    </main>
  );
}

export type { PageLayoutOutletContext };
export default PageLayout;
